import React from 'react'
import { ErrorBoundary } from 'react-error-boundary'

import { HistoryContainer } from '../features/history/orders/components'
import FallbackErrorMessage from '../utils/errors/FallbackMessage'

export const OrdersHistoryPage: React.FC = () => {
  return (
    <ErrorBoundary FallbackComponent={FallbackErrorMessage}>
      <HistoryContainer />
    </ErrorBoundary>
  )
}
